import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';

import { COLORS } from 'ideta-library/lib/utils/utils';

import { SvgIconType } from './svg-icon.type';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SvgIconComponent implements OnInit, OnChanges {
  @Input() icon: SvgIconType;
  @Input() width?: number;
  @Input() height?: number;
  @Input() size?: number; // Should be used or was used ?
  @Input() fill?: string;
  @Input() class?: string;
  @Input() viewBox?: string;
  @Input() pathStyle?: any;
  @Input() selected?: boolean;

  constructor(private cdr: ChangeDetectorRef) {
    this.fill = 'none';
  }

  get pathStyleHtml(): any {
    switch (this.icon) {
      case 'navigate':
        return this.pathStyle || { fill: COLORS.gray7 };
      default:
        return this.pathStyle;
    }
  }

  get fillCircle(): string {
    return this.fill !== 'none' ? this.fill : 'white';
  }

  ngOnInit(): void {
    this.width = this.width ?? this.size ?? 0;
    this.height = this.height ?? this.size ?? 0;
  }

  ngOnChanges(): void {
    this.cdr.markForCheck();
  }
}
